<template lang="pug">
  modal(:closeButton='closeButton' @closeModal='hideElement(thanksModal)')
    .image-container.column.center
      h2.title-medium.text-center.m-top-6
        | {{ $t('informationProgram.thanks') }}
      h3.text-big.text-center.contact.m-top-1
        | {{ $t('informationProgram.contact') }}
</template>

<script>
import { mapActions } from 'vuex'

import Modal from '@/components/Modal'

export default {
  data() {
    return {
      thanksModal: {
        element: 'thanksModal'
      }
    }
  },
  props: {
    closeButton: { type: Boolean, required: false, default: true }
  },
  methods: {
    ...mapActions([
      'hideElement',
      'showElement'
    ])
  },
  components: { Modal }
}
</script>

<style lang="scss" scoped>
@import '../../scss/variables/colors';

.image-container {
  background: url('../../assets/ic_thanks.svg') no-repeat 70px 0;
  height: 250px;
  width: 100%;
}

.contact {
  color: $dark-gray;
  width: 85%;
}
</style>
